
import Vue from "vue";
import $ from "jquery";
import filters from "@/filters";
import Component from "vue-class-component";
import { saveAs } from "file-saver";
import { AxiosResponse } from "axios";
import { Action, Mutation, State } from "vuex-class";

import { TRACER_STUDY_STATUS_TYPE, tracerStudyPaymentStatus } from "@/constants/enum.constant";
import { TracerStudyModel } from "@/models/tracerstudy.model";

import ModalEditTracer from "@/views/apps/tracerstudy/modal/ModalEditTracer.vue";
import ModalConfirmCopy from "@/views/apps/tracerstudy/modal/ModalConfirmCopy.vue";
import ModalConfirmDelete from "@/views/apps/tracerstudy/modal/ModalConfirmDelete.vue";
import ModalConfirmDownload from "@/views/apps/tracerstudy/modal/ModalConfirmDownload.vue";
import { PaginationState } from "@/store/types";
import toast from "@/functions/toast.function";
import ModalTracerStudyReUploadPayment from "@/components/tracer-study/ModalTracerStudyReUploadPayment.vue";
import ModalTracerStudyTerms from "@/components/tracer-study/ModalTracerStudyTerms.vue";

@Component({
  filters,
  components: {
    ModalTracerStudyTerms,
    ModalTracerStudyReUploadPayment,
    ModalEditTracer,
    ModalConfirmCopy,
    ModalConfirmDelete,
    ModalConfirmDownload,
  },
})
export default class TracerStudy extends Vue {
  /* VUEX */

  /* ACTIONS */
  @Action("actionGetListTracerStudy", {namespace: "tracerstudy"})
  private actionGetListTracerStudy: any;
  @Action("actionDetailTracerStudy", {namespace: "tracerstudy"})
  private actionDetailTracerStudy: any;
  @Action("actionCopyTracerStudy", {namespace: "tracerstudy"})
  private actionCopyTracerStudy: any;
  @Action("actionDeleteTracerStudy", {namespace: "tracerstudy"})
  private actionDeleteTracerStudy: any;
  @Action("actionDownloadTracerStudy", {namespace: "tracerstudy"})
  private actionDownloadTracerStudy: any;

  /* STATE */
  @State("listTracerStudy", {namespace: "tracerstudy"})
  private listTracerStudy: any[];
  @State("tracerStudyPagination", {namespace: "tracerstudy"})
  private tracerStudyPagination: PaginationState;

  /* INITIALIZATIONS */
  private showTracer: boolean = true;
  private search: string = "";
  private statusType = TRACER_STUDY_STATUS_TYPE;
  private selectedTracer: TracerStudyModel = new TracerStudyModel();
  private showModalEdit: boolean = false;
  private showConfirmCopy: boolean = false;
  private showConfirmDelete: boolean = false;
  private showConfirmDownload: boolean = false;
  private showModalTerms: boolean = false;
  private showModalPayment: boolean = false;
  private currentPaymentId: number = 0;
  private currentTracerStudyId: number = 0;
  private currentPaymentNote: string = "";

  private onLoad = false;
  private activePage = 1;

  private created() {
    this.getList();
  }

  /* METHODS */
  private isExpired(tracer: TracerStudyModel) {
    return tracer.status === TRACER_STUDY_STATUS_TYPE.Expired;
  }
  private openTerms() {
    this.showModalTerms = true;
  }
  private getList() {
    this.actionGetListTracerStudy({
      params: {},
      success: () => {
        this.listenScroll();
      },
    });
  }

  private getPaymentStatus(payment: any) {
    if (payment === null) {
      return "-";
    } else {
      const lastStatus = payment.statuses[payment.statuses.length - 1].status;
      if (lastStatus === tracerStudyPaymentStatus.UNPAID) return "Unpaid";
      else if (lastStatus === tracerStudyPaymentStatus.WAITING_APPROVAL) return "Waiting Approval";
      else if (lastStatus === tracerStudyPaymentStatus.REJECTED) return "Rejected";
      else if (lastStatus === tracerStudyPaymentStatus.PAID) return "Paid";
      else return "-";
    }
  }

  private listenScroll() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    // INFINITE SCROLL PAGINATION
    $(window).scroll(function () {
      // End of the document reached?
      const dHeight = $(document).height() as number;
      const wHeight = $(this).height() as number;
      const sHeight = ($(this).scrollTop() as number + 1).toString();

      if (parseInt(sHeight) >= dHeight - wHeight) {
        if (!self.onLoad) {
          if (self.listTracerStudy.length === 0) {
            return;
          }
          // Has pagination url?
          const {name} = self.$route;
          if (name === "tracerStudy" && self.tracerStudyPagination.url) {
            self.activePage++;
            self.clickPage(self.activePage);
          }
        }
      }
    });
  }

  private clickPage(page: number) {
    this.onLoad = true;

    if (page > 1) {
      this.actionGetListTracerStudy({
        params: {page: page},
        success: () => {
          this.onLoad = false;
        },
      });
    } else {
      this.actionGetListTracerStudy({
        params: {},
        success: () => {
          this.onLoad = false;
        },
      });
    }
  }

  private searchTracer(searchValue: string) {
    this.actionGetListTracerStudy({
      params: {search: searchValue},
      success: (data: any) => {
        (this.$refs.searchTracerRef as any).hide();
      },
    });
  }

  private checkTracer(tracer: any) {
    if (tracer.payment === null) {
      this.detail(tracer);
    } else {
      const lastStatus = tracer.payment.statuses[tracer.payment.statuses.length - 1].status;
      if (lastStatus === tracerStudyPaymentStatus.WAITING_APPROVAL) toast.warning(this.$i18n.t("subscription_info_waiting_approval"));
      else if (lastStatus === tracerStudyPaymentStatus.REJECTED) toast.warning(this.$i18n.t("subscription_info_rejected"));
      else if (lastStatus === tracerStudyPaymentStatus.PAID) this.detail(tracer);
      else toast.warning("Whoops, something went wrong.");
    }
  }

  private detail(tracer: any) {
    this.actionDetailTracerStudy({
      id: tracer.id,
      success: (data: any) => {
        if ([2,3].indexOf(tracer.status) >= 0) {
          this.$router.push({
            name: "tracerRespondent",
            params: {tracer_id: String(tracer.id)},
          });
        } else {
          this.$router.push({
            name: "tracerQuestions",
            params: {tracer_id: tracer.id.toString()},
          });
        }
      },
    });
  }

  private editTracer(tracer: TracerStudyModel) {
    this.selectedTracer = tracer;
    tracer.show_dropdown = false;
    this.showModalEdit = true;
  }

  private openReUploadPaymentModal(tracer: any) {
    this.showModalPayment = true;
    this.currentPaymentId = tracer.payment.id;
    this.currentTracerStudyId = tracer.id;
    this.currentPaymentNote = tracer.payment.statuses[tracer.payment.statuses.length - 1].note;
  }

  private canReUpload(tracer: any) {
    if (tracer.payment === null) {
      return false;
    } else {
      const lastStatus = tracer.payment.statuses[tracer.payment.statuses.length - 1].status;
      return lastStatus === tracerStudyPaymentStatus.UNPAID || lastStatus === tracerStudyPaymentStatus.REJECTED;
    }
  }

  private onEditSubmited(response: AxiosResponse) {
    this.clickPage(1);
  }

  private onCopyTracer(tracer: TracerStudyModel) {
    tracer.show_dropdown = false;
    this.actionCopyTracerStudy({
      id: tracer.id,
    }).then((response: AxiosResponse) => {
      if (response) {
        this.clickPage(1);
      }
    });
  }

  private onDeleteTracer(tracer: TracerStudyModel) {
    var index = -0;
    this.actionDeleteTracerStudy({
      id: tracer.id,
      params: tracer,
    }).then((response: AxiosResponse) => {
      this.actionGetListTracerStudy({params: {}});
    });
  }

  private onDownloadTracer(tracer: TracerStudyModel) {
    this.actionDownloadTracerStudy({
      id: tracer.id,
      params: tracer,
    }).then((response: AxiosResponse) => {
      saveAs(response.data, `${tracer.title}.xlsx`, {autoBom: true});
    });
  }
}
